import { RestBase } from './base'
import { Track } from '@/ts/interfaces/track'

export class RestTrack {
  private rest: RestBase

  constructor() {
    this.rest = new RestBase()
  }

  public get(partyId: number): Promise<{ items: Track[], options: { type: string, id: string, service: string, country: string }, excluded: Track[] }> {
    return this.rest.get(`/api/parties/${partyId}/tracks`, { withCmsAuth: true })
  }

  public update(partyId: number, type: string, id: string, service: string, country: string): Promise<{ items: Track[], options: { type: string, id: string, service: string, country: string }, excluded: Track[] }> {
    return this.rest.put(`/api/parties/${partyId}/tracks`, { body: { type, id, service, country }, withCmsAuth: true })
  }

  public vote(token: string, partyId: number, trackId: string) {
    return this.rest.post(`/api/parties/${partyId}/tracks/${trackId}/votes`, { headers: this.rest.bearerAuthorizationHeader(token) })
  }

  public unvote(token: string, partyId: number, trackId: string) {
    return this.rest.delete(`/api/parties/${partyId}/tracks/${trackId}/votes`, { headers: this.rest.bearerAuthorizationHeader(token) })
  }
}
